module.exports = __webpack_public_path__ + "static/img/workSite4.7697b9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/workSite4.png
// module id = 27VJ
// module chunks = 1